import { render, staticRenderFns } from "./gateway-settings-select.vue?vue&type=template&id=420d4ec8&"
import script from "./gateway-settings-select.vue?vue&type=script&lang=js&"
export * from "./gateway-settings-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports